import styled from "styled-components"

export const primary = {
  background: "#000",
  foreground: "#fff",
  black: "#000",
  white: "#fff"
}

export const secondary = {
  background: "#FDDF05",
  foreground: "#000",
  text: "#FFE100",
  background60: "rgba(255, 225, 0, 0.60)",
  background03: "rgba(255, 222, 0, 0.3)",
  background030: "rgba(255, 255, 0, 0.30)",
  background016: "rgba(255, 225, 0, 0.16)",
  background_black05: "rgba(0, 0, 0, 0.05)",
  background40: "rgba(255, 225, 0, 0.40)",
  background15: "rgba(255, 225, 0, 0.15)"
}

export const device_px = {
  MAX_1919: "1919px",
  MAX_1439: "1439px",
  MAX_1279: "1279px",
  MAX_767: "767px"
}

export const device_number = {
  MAX_1919: 1919,
  MAX_1439: 1439,
  MAX_1279: 1279,
  MAX_767: 767
}

export const gray = {
  C3: "#C3C3C3",
  D9: "#D9D9D9",
  FF80: "rgba(255, 255, 255, 0.8)",
  FF60: "rgba(255, 255, 255, 0.6)",
  55: "#555555",
  77: "#777777",
  FF40: "rgba(255, 255, 255, 0.4)",
  FF20: "rgba(255, 255, 255, 0.2)",
  FF020: "rgba(255, 255, 255, 0.2)",
  18: "#181818",
  2: "#1F1F1F",
  aa: "#aaa"
}

export const white = {
  "80": "rgba(255, 255, 255, 0.80)",
  "60": "rgba(255, 255, 255, 0.60)",
  "40": "rgba(255, 255, 255, 0.40)",
  "20": "rgba(255, 255, 255, 0.20)"
}

export const black = {
  "1C": "#1c1c1c",
  "10": "#101010",
  "1F": "#1f1f1f",
  "33": "#333333",
  "0060": "rgba(0, 0, 0, 0.6)",
  "18": "#181818",
  "00": "#000000"
}

export const red = {
  FF0: "#ff0000"
}

export const yellow = {
  FF0: "#ffe000",
  FF: "#ffe100",
  FDD: "#FDDF05",
  "25FF": "#ffe10040"
}

export const about_page_padding = {
  desktop: 160,
  desktop_1280_1919: 80,
  tablet_768_1279: 20,
  mobile_360_767: 10
}

export const about_page_padding_px = {
  desktop: "160px",
  desktop_1280_1919: "80px",
  tablet_768_1279: "20px",
  mobile_360_767: "10px"
}

export const offline_page_padding = {
  desktop: 380,
  desktop_1280_1919: 60,
  tablet_768_1279: 30,
  mobile_360_767: 10
}

export const session_page_padding = {
  mobile_360_767: 15
}

export const my_session_page_padding = {
  mobile_360_767: 10
}

export const ContentContainer = styled.div`
  max-width: 1920px;
  margin: 0 auto;
`
